const CHRISTMAS_PARTY_TAG_ID = 103;

// US/CA display "Holiday Party" instead of "Christmas Party"; the filter still targets tag 103.
export const HOLIDAY_LABEL_COUNTRY_CODES = ['US', 'CA'];

export const quickFilterLabel = (quickFilter, ISOCountryCode) => (
  quickFilter.type === 'room_tags'
    && quickFilter.values.map(Number).includes(CHRISTMAS_PARTY_TAG_ID)
    && HOLIDAY_LABEL_COUNTRY_CODES.includes(ISOCountryCode)
    ? 'Holiday Party'
    : quickFilter.label
);

/**
 * Resolves the display label of an applied filter value from the quick filters passed by the
 * backend. Returns null when no quick filter covers the value - a page shows at most 50 quick
 * filters, so a value hydrated from the URL may have no label available here.
 *
 * @param {string[]} types quick filter types the value can belong to, e.g. ['room_features', 'venue_type']
 */
export const findQuickFilterLabel = (quickFilters, types, value, ISOCountryCode) => {
  const quickFilter = quickFilters.find((filter) => types.includes(filter.type)
    && filter.values.some((filterValue) => String(filterValue) === String(value)));

  return quickFilter ? quickFilterLabel(quickFilter, ISOCountryCode) : null;
};
